import { AppBar, Toolbar, Typography, Box } from "@mui/material";
import uasRaichur from "../../assets/uasRaichur.jpg";
import { useAppContext } from "../../context/AppContext";
import BackButton from "../common/BackButton";
import LogoutButton from "../common/LogoutButton";
import { useLocation } from "react-router-dom";

export default function NavBar() {

  const { customer, loadingCustomer, user } = useAppContext();

  const location = useLocation();
  const isHomePage = location.pathname === "/";

  if (loadingCustomer) return null;

  const logoSrc = customer?.logoPath || uasRaichur;
  const organizationName = customer?.displayName || "Agriculture Tech";

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: "#18693c",
        height: 100,
        justifyContent: "center",
        px: 4,
        borderRadius: 0,
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: "100px",
          display: "flex",
          alignItems: "center",
        }}
      >

        {/* ===== BACK BUTTON – EXTREME LEFT ===== */}
        <Box sx={{ position: "absolute", left: 20 }}>
          {user && !isHomePage && <BackButton />}
        </Box>

        {/* ===== LOGO SECTION ===== */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            ml: 15,          
          }}
        >
          <Box
            component="img"
            src={logoSrc}
            alt="Logo"
            sx={{
              width: 95,
              height: 87,
              borderRadius: "100%",
              objectFit: "cover",
            }}
          />
        </Box>

        {/* TITLE */}
        <Box sx={{ flex: 1, textAlign: "center" }}>
          <Typography
            sx={{
              fontWeight: 700,
              color: "#fff",
              fontSize: "30px",
              lineHeight: 1.2,
            }}
          >
            {organizationName}
          </Typography>
        </Box>

        {/* ===== LOGOUT  ===== */}
        <Box sx={{ mr: 4 }}>
          {user && <LogoutButton />}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
